import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import holly from '../assets/brand/holly.webp';
import { siteLinks } from '../data.js';
import { ArrowUpRightIcon, CloseIcon, MenuIcon } from './Icons.jsx';

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'The show', to: '/about' },
  { label: 'Cast & fam', to: '/cast' },
  { label: 'Media', to: '/media' },
];

function SkipLink() {
  return (
    <a className="skip-link" href="#main-content">
      Skip to content
    </a>
  );
}

export function Layout({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);

  return (
    <div className="site-shell">
      <SkipLink />
      <header className="site-header">
        <NavLink className="wordmark" to="/" aria-label="Uncle Mike Ruins Christmas home">
          <span className="wordmark-mark" aria-hidden="true">UMRX</span>
          <span className="wordmark-text">Uncle Mike Ruins Christmas</span>
        </NavLink>

        <nav className="desktop-nav" aria-label="Main navigation">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.to === '/'}>
              {item.label}
            </NavLink>
          ))}
          <a className="button button-small" href={siteLinks.ticketUrl} target="_blank" rel="noreferrer">
            Tickets <ArrowUpRightIcon />
          </a>
        </nav>

        <button
          className="menu-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="mobile-navigation"
          aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>
      </header>

      <div className={`mobile-menu ${menuOpen ? 'is-open' : ''}`} id="mobile-navigation">
        <nav aria-label="Mobile navigation">
          {navItems.map((item, index) => (
            <NavLink key={item.to} to={item.to} end={item.to === '/'}>
              <span>0{index + 1}</span> {item.label}
            </NavLink>
          ))}
          <a href={siteLinks.ticketUrl} target="_blank" rel="noreferrer">
            <span>05</span> Tickets <ArrowUpRightIcon />
          </a>
          <img src={holly} alt="" aria-hidden="true" />
        </nav>
      </div>

      <main id="main-content">{children}</main>

      <footer className="site-footer">
        <div>
          <span className="footer-kicker">Seattle, Washington</span>
          <p>Ruining your cherished holiday memories since 2007.</p>
        </div>
        <div className="footer-meta">
          <a href="mailto:unclemikeruinschristmas@gmail.com">Email Uncle Mike</a>
          <span>© {new Date().getFullYear()} UMRX</span>
        </div>
      </footer>
    </div>
  );
}
